"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _constants = require("draft-plugins/lib/constants");

var _default = function _default(url, isTargetBlank, isNoFollow) {
  return [_constants.LINK_ENTITY_TYPE, 'MUTABLE', {
    url: url,
    isNoFollow: isNoFollow,
    isTargetBlank: isTargetBlank
  }];
};

exports.default = _default;
module.exports = exports.default;